:host {
  display: block;
  @include eon-typography();

  @include slotted-margins("*:not([slot])");
}

.#{$prefix}page-header-wrapper {
  display: flex;
  flex-direction: row;

  @if variable-exists(page-header-default-radius) {
    border-radius: $page-header-default-radius;
  }

  @if variable-exists(page-header-default-shadow) {
    box-shadow: $page-header-default-shadow;
  }

  @include for-size(phone) {
    flex-direction: column;
  }

  .#{$prefix}image-headline-container {
    position: relative;
    z-index: 1;
    height: auto;
    width: calc(100% * 8 / 12);

    @include for-size(phone) {
      width: auto;
    }

    .#{$prefix}header-image-content {
      position: absolute;
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      flex-direction: column;
      padding: 48px;
      box-sizing: border-box;

      @include for-size(tablet) {
        padding: 32px;
      }
      @include for-size(phone) {
        padding: 24px;
      }

      &.#{$prefix}left {
        align-items: flex-start;
      }

      &.#{$prefix}center {
        align-items: center;
      }

      &.#{$prefix}right {
        align-items: flex-end;
      }
    }

    .#{$prefix}image-section {
      height: 100%;

      @include for-size(phone) {
        min-height: 320px;
      }

      @include for-size(tablet) {
        min-height: 400px;
      }

      @include for-size(desktop-or-larger) {
        min-height: 480px;
      }

      @if variable-exists(page-header-default-radius) {
        @include for-size(tablet-or-larger) {
          height: 100%;
          max-height: unset !important;
        }
      }

      @if variable-exists(page-header-default-shadow) {
        @include for-size(tablet-or-larger) {
          height: 100%;
          max-height: unset !important;
        }
      }

      .#{$prefix}page-header-violator {
        margin-bottom: 16px;

        &.#{$prefix}left {
          align-self: flex-start;
        }

        &.#{$prefix}right {
          align-self: flex-end;
        }
      }

      .#{$prefix}headline-section {
        display: flex;
        flex-grow: 1;
        z-index: 1;
        word-wrap: break-word; // For EDGE 18
        word-break: break-word; // For Chrome, Safari, Firefox

        &.#{$prefix}top {
          align-items: flex-start;
        }

        &.#{$prefix}middle {
          align-items: center;
        }

        &.#{$prefix}bottom {
          align-items: flex-end;
        }
      }

      &::after {
        @include aspect-ratio(2, 1);
      }

      @include for-size(tablet) {
        &::after {
          @include aspect-ratio(2, 1);
        }
      }

      @include for-size(desktop) {
        &::after {
          @include aspect-ratio(2, 1);
        }
      }

      @include for-size(desktop-l-or-larger) {
        &::after {
          @include aspect-ratio(4, 1);
        }
      }

      @if variable-exists(page-header-default-radius) {
        @include for-size(tablet) {
          &::after {
            @include aspect-ratio(2, 1);
          }
        }
      }
      @if variable-exists(page-header-default-shadow) {
        @include for-size(tablet) {
          &::after {
            @include aspect-ratio(2, 1);
          }
        }
      }
    }

    .#{$prefix}color-bars {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      height: 100%;
      background-color: v(currentColorBar);
      width: 24px;
      @include for-size(tablet) {
        width: 16px;
      }
      &.#{$prefix}offset-bar {
        left: 40px;
        @include for-size(tablet) {
          left: 24px;
        }
      }
    }
  }

  .#{$prefix}content-section {
    position: relative;
    z-index: 91;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    height: auto;
    min-height: 4px;
    width: calc(100% * 4 / 12);
    @include for-size(phone) {
      width: auto;
    }
    @include for-size(tablet-or-larger) {
      min-width: 340px;
    }

    .#{$prefix}content-background {
      position: absolute;
      right: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: v(backgroundColor);
    }

    .#{$prefix}content-contrast-bar {
      height: 100%;
      width: 96px;
      right: 0px;
      position: absolute;
      overflow: hidden;
      @include for-size(tablet) {
        width: 72px;
      }
    }

    .#{$prefix}wide-contrast-bar {
      background-color: v(wideShade);
      position: absolute;
      right: 0px;
      height: 100%;
      z-index: 1;
      width: 72px;
      @include for-size(tablet) {
        width: 56px;
      }
    }

    .#{$prefix}narrow-contrast-bar {
      background-color: v(narrowShade);
      position: absolute;
      right: 0px;
      height: 100%;
      z-index: 1;
      width: 24px;
      @include for-size(tablet) {
        width: 16px;
      }
    }

    .#{$prefix}wide-contrast-bar-animation {
      @media screen and (prefers-reduced-motion: no-preference) {
        right: -72px;
        animation-name: widecontrastbar;
        animation-delay: 0.2s;
        animation-duration: 0.9s;
        animation-fill-mode: forwards;
      }
    }

    .#{$prefix}narrow-contrast-bar-animation {
      @media screen and (prefers-reduced-motion: no-preference) {
        right: -24px;
        animation-name: narrowcontrastbar;
        animation-delay: 0.5s;
        animation-duration: 0.7s;
        animation-fill-mode: forwards;
      }
    }

    @keyframes widecontrastbar {
      0% {
        right: -72px;
      }
      100% {
        right: 0;
      }
    }

    @keyframes narrowcontrastbar {
      0% {
        right: -24px;
      }
      100% {
        right: 0;
      }
    }

    .#{$prefix}content {
      display: flex;
      flex-direction: column;
      width: 100%;
      z-index: 1;
      padding: 48px;
      word-wrap: break-word; // For EDGE 18
      word-break: break-word; // For Chrome, Safari, Firefox
      box-sizing: border-box;

      > * {
        max-width: 100%;
      }

      @include for-size(tablet) {
        padding: 32px;
      }
      @include for-size(phone) {
        padding: 24px;
      }

      .#{$prefix}sub-content {
        display: flex;
        flex-direction: column;
        padding-top: 32px;
        @include for-size(phone) {
          padding-top: 24px;
        }
        &.#{$prefix}no-subheadline {
          padding-top: 0;
        }
      }

      &.#{$prefix}alignment-left {
        align-items: flex-start;
        .#{$prefix}sub-content {
          text-align: left;
          align-items: flex-start;
        }
      }
      &.#{$prefix}alignment-center {
        align-items: center;
        .#{$prefix}sub-content {
          text-align: center;
          align-items: center;
        }
      }
      &.#{$prefix}alignment-right {
        align-items: flex-end;
        .#{$prefix}sub-content {
          text-align: right;
          align-items: flex-end;
        }
      }

      .#{$prefix}cta-content {
        display: block;
        padding-top: 32px;
        @include for-size(phone) {
          padding-top: 24px;
        }
      }
    }
  }

  &.#{$prefix}has-colorbar-offset {
    .#{$prefix}headline-section {
      @include for-size(tablet-or-larger) {
        padding-left: 64px;
      }
    }
  }
}

::slotted([slot="header-subheadline"]) {
  color: v(contentColor);
}

::slotted([slot="header-content"]) {
  color: v(contentColor);
  max-width: 100%;
}
